const logoPaginaDofollow =
  'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Plan Oro — Presencia total y autoridad',
    annualPrice: 'Trimestral: consultar',
    monthlyPrice: 'Mensual: consultar',
    features: [
      'Audiovisual: spot comercial en video (20 s) antes y después del programa + 2 paquetes semanales de inserciones en la grilla de streaming de TNO.',
      'Integración: presentación y cierre del programa con logo o eslogan + 3 inserts visuales durante el episodio.',
      'Redes y digital: banner horizontal premium en el home de la web + logo de su marca en 2 videos cortos (Reels/Shorts) derivados de cada programa.',
      'Patrocinante exclusivo: máxima visibilidad y narrativa alineada al media kit oficial.',
      'Condición sugerida: contratación mínima de 3 meses para consolidar el efecto «vida perpetua» del contenido.',
      logoPaginaDofollow,
    ],
    idealFor:
      'Marcas de consumo masivo, retail, telecomunicaciones y servicios que buscan liderazgo de categoría con conversación de alto valor sobre publicidad y negocio.',
    duration: 'Mínimo 3 meses (recomendado)',
    buttonText: 'Consultar Plan Oro',
    highlightedTitle: 'Patrocinante exclusivo',
    highlightedContent: [
      'Presencia total en audio, video y redes con la estética del programa.',
      'Su marca en el momento de mayor atención: apertura, desarrollo y cierre.',
    ],
    highlightedButtonText: 'Hablar con comercial',
  },
  {
    title: 'Plan Plata — Alcance híbrido',
    annualPrice: 'Trimestral: consultar',
    monthlyPrice: 'Mensual: consultar',
    features: [
      'Audiovisual: mención orgánica de 15 segundos por parte de la host (endorsement y transferencia de credibilidad).',
      'Integración: 2 inserts visuales de su marca durante las entrevistas clave de cada episodio.',
      'Redes y digital: banner cuadrado en el portal web + logo integrado en las promociones de redes del episodio semanal.',
      'Aliado estratégico: equilibrio entre visibilidad y inversión.',
      logoPaginaDofollow,
    ],
    idealFor:
      'Marcas en servicios, educación, B2B y pymes que buscan presencia constante sin el alcance completo del Plan Oro.',
    duration: 'Suscripción mensual o trimestral',
    buttonText: 'Consultar Plan Plata',
    highlightedTitle: 'Alcance híbrido',
    highlightedContent: [
      'Combinación de mención orgánica, inserts en entrevistas y activación digital.',
      'Ideal para refuerzo de reputación y consideración de marca.',
    ],
    highlightedButtonText: 'Solicitar propuesta',
  },
  {
    title: 'Plan Bronce — Visibilidad focalizada',
    annualPrice: 'Trimestral: consultar',
    monthlyPrice: 'Mensual: consultar',
    features: [
      'Audiovisual: agradecimiento institucional al cierre del programa.',
      'Digital: un artículo patrocinado mensual (advertorial) en el portal web, enmarcado en contexto de marcas y medios.',
      'Redes: menciones estratégicas en historias de Instagram en @tnonetwork y cuentas vinculadas al programa.',
      'Presencia digital y PR con foco en credibilidad editorial.',
      logoPaginaDofollow,
    ],
    idealFor:
      'PYMES, estudios creativos boutique y marcas que inician en patrocinio de contenido brand safe sobre publicidad y consumo.',
    duration: 'Mensual',
    buttonText: 'Consultar Plan Bronce',
    highlightedTitle: 'Entrada al ecosistema',
    highlightedContent: [
      'Visibilidad focalizada con menor fricción operativa.',
      'Perfecto para pruebas de concepto o campañas puntuales.',
    ],
    highlightedButtonText: 'Agendar llamada',
  },
  {
    title: 'Entrevista o bloque patrocinado',
    annualPrice: 'Por sesión: consultar',
    monthlyPrice: 'Consultar',
    features: [
      'Bloque dedicado con especialista o vocero de la marca (duración a acordar).',
      'Mención de puntos de venta y propuesta con respaldo visual en pantalla cuando aplique.',
      'Derivados para redes bajo coordinación con producción TNO.',
      logoPaginaDofollow,
    ],
    idealFor: 'Expertos, agencias y aliados que desean una aparición profunda en un solo episodio.',
    duration: 'Por sesión',
    buttonText: 'Agendar entrevista',
    highlightedTitle: 'Autoridad en un capítulo',
    highlightedContent: [
      'Concentre su mensaje en un episodio con contexto publicitario y de negocio.',
      'Ideal para lanzamientos o posicionamiento de vocería.',
    ],
    highlightedButtonText: 'Ver calendario',
  },
  {
    title: 'TNO Digest — Autoridad editorial y SEO',
    annualPrice: 'Trimestral: consultar',
    monthlyPrice: 'Mensual: consultar',
    features: [
      'Artículo o pieza patrocinada en TNO Digest (tnonetwork.com): contexto de marcas, medios y tendencias, con enfoque SEO.',
      'Titulares y CTAs acordados con comercial y con la línea editorial de En Producción con MEM.',
      'Distribución y refuerzo en redes del ecosistema TNO cuando aplique.',
      'Ideal para posicionar vocería, campañas o servicios con intención de búsqueda.',
      logoPaginaDofollow,
    ],
    idealFor:
      'Agencias, consultoras, retail y marcas que buscan autoridad en texto además de presencia en audio y video.',
    duration: 'Por pieza o paquete mensual (consultar)',
    buttonText: 'Consultar TNO Digest',
    highlightedTitle: 'Profundidad que queda en Google',
    highlightedContent: [
      'Su mensaje vive más allá del episodio: contenido indexable y compartible.',
      'Alineación brand safe con temas de publicidad, consumo y cultura de marca.',
    ],
    highlightedButtonText: 'Solicitar propuesta Digest',
  },
  {
    title: 'Micros comerciales — Grilla de streaming TNO',
    annualPrice: 'Pack: consultar',
    monthlyPrice: 'Mensual: consultar',
    features: [
      'Cuñas o micros audiovisuales en rotación en la programación de TNO Network (franjas y frecuencia a acordar).',
      'Posibilidad de emplazamiento contextual cerca de En Producción con MEM u otros espacios brand safe en la grilla de streaming TNO.',
      'Producción o adaptación del spot bajo lineamientos técnicos de TNO.',
      'Reporte de emisiones según formato contratado.',
      logoPaginaDofollow,
    ],
    idealFor:
      'Marcas que necesitan frecuencia en streaming, refuerzo de memorabilidad o apoyo a campañas puntuales sin un plan Oro completo.',
    duration: 'Mensual o por campaña',
    buttonText: 'Consultar micros',
    highlightedTitle: 'Frecuencia en streaming',
    highlightedContent: [
      'Micros de corta duración con alta repetición en el ecosistema en streaming.',
      'Complemento ideal a patrocinio de programa o Digest.',
    ],
    highlightedButtonText: 'Hablar con comercial',
  },
];

export default optionsData;
